import state from './pubreport.state'
import actions from './pubreport.actions'
import mutations from './pubreport.mutations'
import getters from './pubreport.getters'
import persist from '../persist'

export default {
  state,
  actions,
  mutations,
  getters,
  plugins: [persist.plugin],
}
